import { render, staticRenderFns } from "./NewAppHeader.vue?vue&type=template&id=46b5ddd1&scoped=true"
import script from "./NewAppHeader.vue?vue&type=script&lang=ts"
export * from "./NewAppHeader.vue?vue&type=script&lang=ts"
import style0 from "./NewAppHeader.vue?vue&type=style&index=0&id=46b5ddd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5ddd1",
  null
  
)

export default component.exports